import { getOrFetchImage, getOrFetchBinary } from '../modules/assets';
import * as THREE from 'three';


export function getAssetIdFromImage(store, image, preferHDR) {
  const { asset, hdr } = image;
  return preferHDR && image.preferHDR && hdr ? hdr : asset;
}

export function fetchTextureImage(store, image, preferHDR) {
  const id = getAssetIdFromImage(store, image, preferHDR);
  return id && getOrFetchImage(id)(store);
}

/**
 * Fetches and parses hdr file buffer into usage image texture data
 * 
 * @param {any} store
 * @param {any} image
 * @returns {Object} rgbe hdr data of form {width, height, data, header, gamma, exposure, format, type}
 */
export function fetchHDRSourceData(store, image) {
  const id = image.hdrSource;
  if (!id) return null;
  const hdrBuffer = getOrFetchBinary(id)(store);
  if (!hdrBuffer) return null;
  const hdrArrayBuffer = new Uint8Array(hdrBuffer);
  const rgbeImageData = new THREE.RGBELoader()._parser(hdrArrayBuffer);
  return rgbeImageData;
}



// WEBPACK FOOTER //
// ./src/translators/asset.js